import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTheme, apiFetch, uploadToS3, viewportWidth, toWidth } from 'helpers'
import Modal, { Overlay, ActionSheets, SlideupView, ConfirmDialog } from 'components/Modal'
import { ObjectID } from 'bson'
import { get, isEqual } from 'lodash'
import styled from 'styled-components'
import { List } from 'react-virtualized'

import { FormGroup, Label, Input, Button } from 'components/Form'
import AspectRatioImage, { AspectRatioImageContainer } from 'components/AspectRatioImage'
import Section, { SectionHeader, SectionHeaderText, SectionHeaderCount, SectionHeaderRight, BtnAdd, SectionBody, BtnSquareAdd, ItemWrapper, getItemWrapperWidth } from './Section'
import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import FullscreenPhoto from 'components/FullscreenPhoto'
import AlbumItem from 'components/AlbumItem'
import Loader from 'components/Loader'

import svgPlusTiffany from 'assets/svg/icon-plus-tiffany.svg'
import svgPencil from 'assets/svg/icon-pencil.svg'
import svgPlus from 'assets/svg/icon-plus.svg'
// import svgFacebook from 'assets/svg/icon-facebook.svg'
import { viewportHeight } from '../../helpers'
import 'pure-react-carousel/dist/react-carousel.es.css'
const limit = 12
const listItemWidth = () => (Math.min(viewportWidth(), 480) - 20) / 3
const FB_PREFIX = 'https://graph.facebook.com/v3.1'

@connect(state => ({
  me: get(state, 'vendor.me'),
  albums: get(state, 'vendor.albums') || [],
  albumCount: get(state, 'vendor.albumCount') || 0,
  loading: get(state, 'vendor.findAlbumsAttempting') || false,
  allVenues: get(state, 'app.allVenues') || []
}))
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menusVisible: false,
      adding: false,
      keyword: '',
      albums: props.albums || [],
      name: ''
    }
    this._loading = {}
    this._photosLoading = {}
  }

  componentDidMount () {
    const { dispatch } = this.props
    Promise.all([
      apiFetch({
        dispatch,
        key: 'COUNT_ALBUMS',
        v4: true,
        url: '/v4/vendors/me/albums/count'
      }),
      apiFetch({
        dispatch,
        key: 'FIND_ALBUMS',
        v4: true,
        url: '/v4/vendors/me/albums',
        query: { limit: 'noLimit' },
        actionParams: { clear: true }
      })
    ])
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.albums, nextProps.albums)) {
      this.setState({ albums: nextProps.albums })
    }
  }

  _onFilesChosen = (e) => {
    const { dispatch } = this.props
    const files = e.target.files
    apiFetch({
      dispatch,
      key: 'ADD_ALBUM',
      method: 'POST',
      v4: true,
      url: '/v4/vendors/me/albums'
    }).then(album => {
      this.setState({ currentAlbum: album, albums: [album].concat(this.state.albums), albumEdited: true, menusVisible: false }, () => this._onAlbumPhotosAdd(files))
    })
  }

  _emptyAlbum = () => ({ currentAlbum: null, albumPhotos: [], name: '', imagePath: '', venue: null, venueId: null, venueName: '', keyword: '', albumEdited: false, albumSaving: false, albumRemoving: false, albumRemoveVisible: false })

  _onAlbumPhotosAdd = (_files) => {
    const { dispatch } = this.props
    const files = Object.keys(_files).map(key => _files[key])
    files.forEach(file => dispatch({ type: 'ADD_VENDOR_PHOTO_ATTEMPT', file, imagePath: null }))
    files.reduce((promise, file, index) =>
      promise.then(() => {
        const photoId = new ObjectID().toString()
        const currentAlbumId = get(this.state, 'currentAlbum._id')
        this.setState({ albumPhotos: (this.state.albumPhotos || []).concat({ _id: photoId }) },
          () =>
            apiFetch({
              method: 'POST',
              v4: true,
              url: '/v4/s3/signed-url',
              body: {
                collectionName: 'albums',
                folderName: currentAlbumId,
                fileName: `${photoId}.${file.type.split('/').pop()}`,
                fileType: file.type
              }
            })
              .then(({ url }) => uploadToS3({ url, file }))
              .then(imagePath => new Promise(resolve => {
                const img = new window.Image()
                img.onload = () => resolve({ imagePath, ratioW2H: img.width / img.height })
                img.src = (window.URL || window.webkitURL).createObjectURL(file)
              }))
              .then(({ imagePath, ratioW2H }) =>
                apiFetch({
                  method: 'POST',
                  v4: true,
                  url: `/v4/vendors/me/albums/${currentAlbumId}/photos`,
                  body: {
                    photoId,
                    imagePath,
                    ratioW2H
                  }
                })
                  .then(({ photo }) =>
                    this.setState({
                      albums: this.state.albums.map(_album => _album._id === photo.album._id ? photo.album : _album),
                      imagePath: photo.album.imagePath,
                      albumPhotos: this.state.albumPhotos.map(_photo => photo._id === _photo._id ? photo : _photo)
                    })
                  )
              )
        )
      })
      , Promise.resolve())
  }

  _onRemovePhoto = (photo) => {
    this.setState({ photoRemoving: true }, () =>
      apiFetch({
        method: 'DELETE',
        v4: true,
        url: `/v4/vendors/me/albums/${get(photo, 'album._id')}/photos/${get(photo, '_id')}`
      })
        .then(() => this.setState({
          photoRemoving: false,
          albums: this.state.albums.map(_album => _album._id === get(photo, 'album._id') ? { ..._album, photoCount: _album.photoCount - 1 } : _album),
          albumPhotos: this.state.albumPhotos.filter(_photo => _photo._id !== photo._id),
          currentPhoto: null
        }))
        .catch(() => this.setState({ photoRemoving: false }))
    )
  }

  _photosRenderer = ({ key, index, style = {}, className }) => {
    const colCount = 3
    const rowIndex = index - 1
    if (index === 0) {
      return (
        <div key={key} className={className} style={{ ...style, position: 'relative' }} onClick={() => this.setState({ albumEdited: true })}>
          <ModalAlbumCover src={toWidth(this.state.imagePath, 960)} />
          <ModalAlbumName>{this.state.name || 'Untitled'}</ModalAlbumName>
          <ModalAlbumLocation>{this.state.venueName || 'ยังไม่ได้ระบุสถานที่'}</ModalAlbumLocation>
          <ModalAlbumBtnEdit>
            <IconPencil src={svgPencil} />
          </ModalAlbumBtnEdit>
        </div>
      )
    }

    const currentRowPhotos = this.state.albumPhotosLoading
      ? Array(3).fill().map((_, index) => ({}))
      : (this.state.albumPhotos || []).slice(
        rowIndex * colCount - (rowIndex === 0 ? 0 : 1),
        (rowIndex + 1) * colCount - 1
      )

    return (
      <Row key={key} className={className} style={style}>
        {rowIndex === 0 && (
          <PhotoItemWrapper>
            <BtnSquareAdd width={listItemWidth()} title='เพิ่มรูปภาพ' onClick={() => this._fileChooser.click()} />
            <input type='file' ref={(input) => { this._fileChooser = input }}
              multiple accept='image/*' style={{ display: 'none' }}
              onChange={(e) => this._onAlbumPhotosAdd(e.target.files)} onClick={e => { e.target.value = null }} />
          </PhotoItemWrapper>
        )}
        {currentRowPhotos.map((photo, rowIndex) => {
          return <PhotoItemWrapper key={rowIndex}>
            {(photo.imagePath && !this.state.albumPhotosLoading) ? (
              <AspectRatioImage src={toWidth(photo.imagePath, 300)}
                onClick={() => this.setState({ currentPhoto: photo })} />
            ) : <Loader />}
          </PhotoItemWrapper>
        })}
      </Row>
    )
  }

  _onSaveAlbum = () =>
    this.setState({ albumSaving: true }, () =>
      apiFetch({
        method: 'PUT',
        v4: true,
        url: `/v4/vendors/me/albums/${get(this.state.currentAlbum, '_id')}`,
        body: {
          name: this.state.name || 'Untitled',
          venue: this.state.venueId,
          venueName: this.state.venueName,
          status: 'A'
        }
      })
        .then((result) =>
          this.setState({
            albumSaving: false,
            albumEdited: false,
            currentAlbum: result,
            albums: this.state.albums.map(album => album._id === result._id ? result : album)
          }, () => this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'บันทึกอัลบั้มสำเร็จ' }))
        )
        .catch(() => this.setState(
          { albumSaving: false },
          () => this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'บันทึกอัลบั้มไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
        ))
    )

  _onRemoveAlbum = () =>
    this.setState({ albumRemoving: true }, () =>
      apiFetch({
        key: 'REMOVE_ALBUM',
        dispatch: this.props.dispatch,
        method: 'DELETE',
        v4: true,
        url: `/v4/vendors/me/albums/${get(this.state.currentAlbum, '_id')}`
      })
        .then(() => this.setState({ ...this._emptyAlbum(), albums: this.state.albums.filter(({ _id }) => _id !== get(this.state.currentAlbum, '_id')) }))
        .catch(() => this.setState({ albumRemoving: false }))
    )

  _onCoverSelect = (photo) =>
    this.setState({ coverSelecting: true }, () =>
      apiFetch({
        method: 'PUT',
        v4: true,
        url: `/v4/vendors/me/albums/${get(this.state.currentAlbum, '_id')}`,
        body: {
          imagePath: get(photo, 'imagePath')
        }
      })
        .then(() => this.setState({
          coverSelecting: false,
          imagePath: photo.imagePath,
          albums: this.state.albums.map(_album => _album._id === get(this.state, 'currentAlbum._id')
            ? { ..._album, imagePath: photo.imagePath }
            : _album
          )
        }, () => this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'ตั้งภาพปกอัลบั้มสำเร็จ' })
        ))
        .catch(() => this.setState(
          { coverSelecting: false },
          () => this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'ตั้งภาพปกอัลบั้มไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
        ))
    )

  _onAlbumClick = (album, index) => {
    const screenWidth = viewportWidth()
    const breakpoint = screenWidth >= 960 ? 4 : screenWidth >= 768 ? 3 : 2
    if (index < breakpoint || this.state.showAllAlbums) {
      this.setState({
        currentAlbum: album,
        name: get(album, 'name') || '',
        keyword: get(album, 'venue.nameEn') || get(album, 'venue.nameTh') || get(album, 'venueName') || '',
        venueId: get(album, 'venue._id') || '',
        venue: get(album, 'venue'),
        venueName: get(album, 'venue.nameEn') || get(album, 'venue.nameTh') || get(album, 'venueName') || '',
        imagePath: get(album, 'imagePath') || '',
        photos: [],
        albumPhotosLoading: true
      }, () =>
        apiFetch({
          v4: true,
          url: `/v4/vendors/me/albums/${album._id}/photos`,
          query: { limit: 'noLimit' }
        })
          .then(albumPhotos => this.setState({ albumPhotosLoading: false, albumPhotos, hasMoreAlbumPhotos: albumPhotos.length === limit }))
          .catch(error => this.setState({ albumPhotosLoading: false, error }))
      )
    } else {
      this.setState({ showAllAlbums: true })
    }
  }

  _onOptionFacebook = () => {
    this.setState({ optionFacebook: true, fbLoggingIn: true }, () =>
      Promise.resolve(window.FB.getAuthResponse())
        .then(result => result
          ? Promise.resolve({
            facebookId: get(result, 'userID'),
            accessToken: get(result, 'accessToken')
          }) : new Promise((resolve, reject) => {
            window.FB.login(loginResult => {
              resolve({
                facebookId: get(loginResult, ['authResponse', 'userID']),
                accessToken: get(loginResult, ['authResponse', 'accessToken'])
              })
            }, { scope: 'manage_pages' })
          })
        )
        .then(({ accessToken, facebookId }) =>
          fetch(`${FB_PREFIX}/me/accounts${URL.format({ query: {
            'access_token': accessToken,
            fields: 'name,picture.type(large)',
            limit: 100
          }})}`)
            .then(res => res.json())
            .then((result) => {
              this.setState({
                accessToken,
                facebookId,
                fbLoggingIn: false,
                optionTitle: 'เพิ่มจาก Facebook',
                pages: result.data.map(({ id, name, picture }) => ({
                  id, name, imageUrl: get(picture, 'data.url')
                })),
                step: 2
              })
            })
        )
    )
  }

  render () {
    const { loading, albumCount, allVenues } = this.props
    const albumWidth = getItemWrapperWidth()
    const overlayVisible = this.state.menusVisible ||
      this.state.viewAll ||
      get(this.state, 'currentAlbum._id')
    const justCreated = get(this.state.currentAlbum, 'status') === 'D'
    const albumPhotosRowCount = 1 + Math.ceil(((this.state.albumPhotos || []).length + 1) / 3)

    return (
      <Section>
        <SectionHeader>
          <SectionHeaderText>อัลบั้ม</SectionHeaderText>
          {!loading && <SectionHeaderCount>{albumCount} อัลบั้ม</SectionHeaderCount>}
          <SectionHeaderRight>
            <BtnAdd onClick={() => this.setState({ menusVisible: true })}>
              <img alt='' src={svgPlusTiffany} />
              <span>เพิ่มอัลบั้ม</span>
            </BtnAdd>
          </SectionHeaderRight>
        </SectionHeader>
        <SectionBody>
          <ItemWrapper desktop>
            <BtnSquareAdd width={albumWidth} title='เพิ่มอัลบั้ม' onClick={() => this.setState({ menusVisible: true })} />
          </ItemWrapper>
          {((loading ? (Array(6).fill().map((_, index) => ({ loading: true }))) : (this.state.albums || [])).filter(({ status }) => status !== 'D').map((album, index) =>
            <ItemWrapper showAll={this.state.showAllAlbums} key={index} count={albumCount} unit='อัลบั้ม'>
              <AlbumItem loading={loading}
                album={album} width={albumWidth}
                onClick={() => this._onAlbumClick(album, index)} />
            </ItemWrapper>
          ))}
        </SectionBody>

        <Overlay visible={overlayVisible} onClick={() => this.setState({
          menusVisible: false,
          viewAll: false,
          ...this._emptyAlbum()
        })}>
          <ActionSheets
            withoutOverlay
            visible={this.state.menusVisible}
            title='เลือกช่องทางการเพิ่มอัลบั้ม'
            onCancel={() => this.setState({ menusVisible: false })}
            options={[
              { key: 'upload', onClick: () => this.refs.fileChooser.click(), title: 'เลือกไฟล์รูป', icon: svgPlus, width: 120 }
              // { key: 'facebook', onClick: this._onOptionFacebook, title: 'เพิ่มจาก Facebook', icon: svgFacebook, width: 120 }
            ]} />
          <input type='file' ref='fileChooser'
            multiple style={{ display: 'none' }}
            onChange={this._onFilesChosen} />
          <SlideupView
            withoutOverlay
            viewType='tall'
            visible={this.state.newAlbumModalVisible}
            title='เพิ่มอัลบั้ม'
            onClose={() => this.setState({ newAlbumModalVisible: false })} />
          <SlideupView
            withoutOverlay
            viewType='full'
            visible={this.state.viewAll}
            title={`อัลบั้มทั้งหมด (${albumCount})`}
            onClose={() => this.setState({ viewAll: false })} />
          <SlideupView
            withoutOverlay
            noPadding
            viewType='full'
            visible={!justCreated && get(this.state, 'currentAlbum._id')}
            title='แก้ไขอัลบั้ม'
            onClose={() => this.setState({ ...this._emptyAlbum() })}>
            <List
              ref='_list'
              rowCount={albumPhotosRowCount}
              style={{ outline: 'none' }}
              scrollToAlignment='start'
              rowRenderer={this._photosRenderer}
              rowHeight={({ index }) => (index < 1 ? 286 : listItemWidth() + 5)}
              width={viewportWidth() < 768 ? viewportWidth() : 480}
              height={viewportHeight() - 41} />
          </SlideupView>
        </Overlay>
        <Overlay visible={this.state.albumEdited}>
          <HorizontalCentered>
            <VerticalCentered>
              <Modal auto style={{ width: viewportWidth() > 768 ? 768 : viewportWidth() }} title={justCreated ? 'เพิ่มอัลบั้ม' : 'แก้ไขอัลบั้ม'}
                onClose={() => this.setState({ ...this._emptyAlbum() })} onClick={() => this.setState({ venueFocused: false })}>
                <FormGroup>
                  <Label>ชื่ออัลบั้ม</Label>
                  <Input type='text' value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
                </FormGroup>
                <FormGroup>
                  <Label onClick={() => this.setState({ venueFocused: true })}>สถานที่</Label>
                  <div style={{ position: 'relative' }}>
                    <Input type='text'
                      style={this.state.venueFocused ? {
                        borderBottomLeftRadius: '0px',
                        borderBottomRightRadius: '0px'
                      } : {}}
                      value={this.state.keyword}
                      onFocus={() => this.setState({ venueFocused: true })}
                      onBlur={() =>
                        setTimeout(() => this.setState({ venueFocused: false }), 200)
                      }
                      onChange={e => this.setState({ keyword: e.target.value.trim() })} />
                    {this.state.venueFocused && (
                      <LocationOptions>
                        {this.state.keyword && allVenues.map(venue => get(venue, 'nameEn') || get(venue, 'nameTh')).indexOf(this.state.keyword) === -1 && (
                          <LocationOption onClick={() => this.setState({ venueName: this.state.keyword, venueFocused: false })}>
                            + {this.state.keyword}
                          </LocationOption>
                        )}
                        {allVenues.filter(venue =>
                          venue.nameEn.toLowerCase().indexOf(this.state.keyword.toLowerCase()) > -1 ||
                          venue.nameTh.indexOf(this.state.keyword) > -1
                        ).map(venue =>
                          <LocationOption key={get(venue, '_id')} onClick={() => {
                            this.setState({
                              venueId: get(venue, '_id'),
                              venueName: get(venue, 'nameEn') || get(venue, 'nameTh'),
                              keyword: get(venue, 'nameEn') || get(venue, 'nameTh'),
                              venueFocused: false
                            })
                          }}>
                            {get(venue, 'nameEn') || get(venue, 'nameTh')}
                          </LocationOption>
                        )}
                      </LocationOptions>
                    )}
                  </div>
                  <Button loading={this.state.albumSaving} style={{ marginTop: 15 }} onClick={this._onSaveAlbum}>{justCreated ? 'เพิ่มอัลบั้ม' : 'บันทึกอัลบั้ม'}</Button>
                  {!justCreated && <Button loading={this.state.albumRemoving} color='colorCoral' style={{ marginTop: 15 }} onClick={() => this.setState({ albumRemoveVisible: true })}>ลบอัลบั้ม</Button>}
                </FormGroup>
              </Modal>
            </VerticalCentered>
          </HorizontalCentered>
          <Overlay visible={this.state.albumRemoveVisible}
            onClose={() => this.setState({ albumRemoveVisible: false })}>
            <ConfirmDialog title='คุณต้องการลบอัลบั้มนี้ ?'
              loading={this.state.albumRemoving}
              onOkay={this._onRemoveAlbum}
              onCancel={() => this.setState({ albumRemoveVisible: false })} />
          </Overlay>
        </Overlay>
        <FullscreenPhoto
          photos={this.state.albumPhotos}
          currentPhoto={this.state.currentPhoto}
          onRemove={this._onRemovePhoto}
          removing={this.state.photoRemoving}
          onCoverSelect={this._onCoverSelect}
          coverSelecting={this.state.coverSelecting}
          onClose={() => this.setState({ currentPhoto: null })} />
      </Section>
    )
  }
}

const ModalAlbumCover = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  vertical-align: top;
  border-bottom: 1px solid ${getTheme`colorBorder`}
`
const ModalAlbumName = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
  margin-top: 10px;
  width: calc(100% - 100px);
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 10px auto 0px;
`
const ModalAlbumLocation = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  color: ${getTheme`colorGray100`};
  line-height: 30px;
  width: calc(100% - 100px);
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
`
const ModalAlbumBtnEdit = styled.div`
  position: absolute;
  right: 10px;
  top: 220px;
  background-color: ${getTheme`colorBorder`};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
`
const IconPencil = styled.img`
  display: block;
  margin: 10px auto;
`

const PhotoItemWrapper = styled(AspectRatioImageContainer)`
  display: inline-block;
  vertical-align: top;
  width: calc(33.33% - 6px);
  border: 1px solid ${getTheme`colorBorder`};
  padding-bottom: calc(33.33% - 6px);
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  background-color: ${getTheme`colorBorder`};
  &:hover { opacity: 0.8; }
  &:nth-child(3n) { margin-right: 0px; }
`

const Row = styled.div`
  width: calc(100% - 10px) !important;
  padding: 0px 5px;
  text-align: left;
`
const LocationOptions = styled.div`
  position: absolute;
  top: 45px;
  left: 0px;
  right: 0px;
  height: calc(100vh - 340px);
  background-color: white;
  overflow: auto;
  border: 1px solid ${getTheme`colorBorder`};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`
const LocationOption = styled.div`
  line-height: 20px;
  color: ${getTheme`colorGray`};
  font-size: 24px;
  font-family: ${getTheme`font2`};
  padding: 10px 0px;
  white-space: initial;
  border-bottom: 1px solid ${getTheme`colorBorder`};
  &:last-child { border-bottom: 0px; }
  text-indent: 10px;
  cursor: pointer;
  background-color: white;
  transition: background-color 0.3s ease;
  &:hover { background-color: ${getTheme`colorBorder`}; }
`



// WEBPACK FOOTER //
// ./src/components/profile/SectionAlbums.js